import axios from "../axios-auth";

export const categoryGroupService = {
  getCategoryGroupList,
  saveCategoryGroup,
  getCategoryGroupDetail,
  getCategoryGroupsByStatus
}

function getCategoryGroupList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/all-category-group", { params });
}

function saveCategoryGroup(categoryGroup) {
  if (!categoryGroup.id) {
    // new category
    return axios.post("/auth/category-group", categoryGroup);
  } else {
    // edit
    return axios.put("/auth/category-group", categoryGroup);
  }
}

function getCategoryGroupDetail(id) {
  return axios.get("/auth/category-group/" + id);
}

function getCategoryGroupsByStatus(status) {
  return axios.get("/auth/category-groups-by-status/" + status);
}